import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableHead, TableRow } from '@material-ui/core'

import { MyHeadCell } from './MyHeadCell'

import { MyTableHeadProps } from '../../types/tableTypes'

export const MyTableHead =
  observer(
    <TColumnId extends string, TRow extends object>
    ({table, visibleColumns, groupHeader}: MyTableHeadProps<TColumnId, TRow>) => {
      const classes = useStyles()

      return (
        <TableHead>
          {
            groupHeader &&
            <TableRow>
              {groupHeader}
            </TableRow>
          }

          <TableRow className={clsx('table_head_row', classes.row)} style={{}}>
            {
              visibleColumns.map(column =>
                <MyHeadCell
                  key={column.id}
                  table={table}
                  column={column}
                />)
            }
          </TableRow>
        </TableHead>
      )
    })

const useStyles = makeStyles(
  ({palette}) => ({
    row: {
      background: palette.mpSkladSecondary.blue
    }
  }))